export * from './WarningIcon';
